<template>
    <div class="relative shadow-md bg-white rounded-2xl select-none h-full gap-8 w-full p-6">
        <template v-if="!loading && stats">
            <div class="relative flex flex-col sm:flex-row items-center sm:items-baseline justify-center sm:justify-between w-full gap-y-4">
                <div class="flex flex-col items-start order-0 " :class="showStatCards ? (notSmallScreen ? 'gap-y-12' : 'gap-y-4') : 'gap-y-2'">
                    <div class="font-normal text-xl text-left flex flex-col">
                        <div class="flex items-center">
                            <span>Good Day, <span class="text-indigo-600"> {{ state.user.name }}</span></span>
                        </div>

                        <div v-if="showStatCards" class="text-gray-400 font-normal text-left text-sm">
                            Have a super day ahead 🌞
                        </div>
                    </div>

                    <a :href="stats.unread_email.link" target="_blank"
                       class="text-indigo-600 hover:text-indigo-400 transition duration-300 cursor-pointer font-light text-xl flex flex-wrap w-full justify-center sm:justify-start items-center gap-x-2">
                        <span>You have <b class="font-black">{{ stats.unread_email.stat }}</b></span>
                        <icon-email class="w-6 h-6 hidden sm:visible"></icon-email>
                        <span>unread emails</span>
                    </a>
                </div>

                <div class="flex flex-col order-1">
                    <button @click="$emit('toggle-stats-card')" class="flex items-center gap-x-1 text-indigo-600 hover:text-indigo-400 transition duration-300">
                        <icon-eye-off v-if="showStatCards" class="w-5 h-5"></icon-eye-off>
                        <icon-eye-on v-else class="w-5 h-5"></icon-eye-on>
                        {{showStatCards ? 'Hide Stats' : 'Show Stats'}}
                    </button>

                    <undraw-moving-notes v-if="showStatCards" class="invisible lg:visible absolute right-0 bottom-0 w-16 h-16 sm:w-24 sm:h-24"></undraw-moving-notes>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="flex justify-center items-center font-medium text-lg text-gray-500">
                <icon-refresh class="h-6 w-6 animate-spin text-indigo-600"/> &nbsp;Loading...
            </div>
        </template>
    </div>
</template>


<script>
import UndrawMovingNotes from "../library/svgs/UndrawMovingNotes";
import Echo from "laravel-echo";

export default {
    name: "WelcomeCardWithInboxStats",

    components: {UndrawMovingNotes},

    props: {
        showStatCards: {
            required: true,
            type: Boolean,
            description: "Show or hide stat cards on home dashboard"
        },
    },

    data () {
        return {
            loading: true,
            stats: null, // "Email and RedRabbit messenger stats"
        };
    },

    mounted () {
        if (this.state.team_type === "service_provider" || this.hasFeature("feat_service_provider_portals")) {
            this.echo = new Echo({
                broadcaster: "pusher",
                key: window.pusherKey,
                cluster: "eu",
                encrypted: true
            });

            this.echo.private("update.channel.list")
            .listen("MessengerChannelListChangedEvent", (event) => {
                this.updateNewMessagesCounter(event);
            });
        }

        this.fetchStats();
    },

    methods: {
        fetchStats () {
            this.loading = true;
            axios.get("/home/inbox/stats")
            .then(response => {
                this.stats = response.data;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                toastr.error(error.data.message);
            });
        },

        updateNewMessagesCounter () {
            axios.get("/home/messages/unread/count")
            .then((response) => {
                this.stats.redrabbit_messages.stat = response.data.total_unread_messages;
            }).catch((error) => {
                toastr.error("Could not fetch unread message count! Error: " + error.message);
            });
        },
    },
};
</script>
